export const SvgConstantDarkModeBackgroundColor = '#10161A';

export const SvgConstantLightTheme = {
    fill: '#fff',
    secondaryFill: '#242528',
};
export const SvgConstantDarkTheme = {
    fill: '#242528',
    secondaryFill: '#fff',
};
export const SvgConstantGrayTheme = {
    fill: '#b0b7bd',
    secondaryFill: '#242528',
};
export const SvgConstantDisabledTheme = {
    fill: '#999999',
    secondaryFill: '#fff',
};
export const SvgConstantEmptyTheme = {
    fill: '#d8d8d8',
    secondaryFill: '#fff',
};
export const SvgConstantPositiveTheme = {
    fill: '#2C9400',
    secondaryFill: '#fff',
};
export const SvgConstantNegativeTheme = {
    fill: '#b00000',
    secondaryFill: '#fff',
};
export const SvgConstantBuilderTheme = {
    fill: '#1C9AEF',
    secondaryFill: '#fff',
};
export const SvgConstantModifiedTheme = {
    fill: '#1C9AEF',
    secondaryFill: '#1C9AEF',
};
export const SvgConstantDarkModePositiveTheme = {
    fill: '#00c797',
    secondaryFill: SvgConstantDarkModeBackgroundColor,
};
export const SvgConstantDarkModeNegativeTheme = {
    fill: '#c53131',
    secondaryFill: SvgConstantDarkModeBackgroundColor,
};
